import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProtectedRoute = ({ children }) => {
  // null = checking, true = authenticated, false = not authenticated
  const [authState, setAuthState] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${BACKEND_URL}/api/admin/me`, { withCredentials: true })
      .then(() => {
        if (mounted) setAuthState(true);
      })
      .catch(() => {
        if (mounted) setAuthState(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (authState === null) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-400"
      >
        Comprobando sesión...
      </div>
    );
  }

  if (authState === false) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
